import axios from 'axios';

import { EmployeeCostCenterAction } from 'components/flex-portal/match/types';

import { ROSTER_REQUESTS_MATCH_ACTIONS } from 'RestAPIs/endpoints';

type SaveMatchSettingsProps = {
  requestIds: number[];
  employeeCostCenterActions: EmployeeCostCenterAction[];
  emailAddressToRespond?: string | null;
};

export const saveMatchSettings = ({
  requestIds,
  employeeCostCenterActions,
  emailAddressToRespond
}: SaveMatchSettingsProps) =>
  axios.put(ROSTER_REQUESTS_MATCH_ACTIONS, {
    requestIds,
    employeeCostCenterActions,
    emailAddressToRespond
  });
